const mandatoryFields = ['first_name', 'last_name', 'role'];

export default mandatoryFields;
